import type { FaireProductEntity } from "../../entity_types/product";

export const p_8c8zg4ah9v: FaireProductEntity = {
  token: "p_8c8zg4ah9v",
  type: "product",
  name: "You're a Gem Just Because 4 oz. Candle Tin",
  brandToken: "b_e9fcfadb",
  brandName: "GP Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/323c7fbb3e19c86fa4ced70c849a5ca5df78fbf9845621de170e20147fc67839.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a63ef7ec10aa35e2a5596ad779c6596fb6d49876ad1b067400ba747501c2206d.jpeg",
    "https://cdn.faire.com/fastly/cfa8d12f145c1a4c8626ff60cd42bbd278cdb6a83448ea9b58e337e065477440.jpeg",
    "https://cdn.faire.com/fastly/dce83a234effa0e51ac5bd7af0a9fcd6ac2d70a214309bb34229b92e4879b516.jpeg",
    "https://cdn.faire.com/fastly/f6979c55e89926ac99169ddd28dc2bab87cb9990e864011705f4c5a331686b3b.jpeg",
    "https://cdn.faire.com/fastly/b382ee3397b780e494d7efed82995fb013f58802bb98ee030652b3e8188c4d1f.jpeg",
    "https://cdn.faire.com/fastly/a86812817d0eb9853c86dff48c276c13b8c0d165b0e8dfcf7d623e813c386848.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Warm their hearts and brighten their day with our Just Because Collection! This Collection of giftable tins is perfect for any occasion.\n\nYou're a Gem features notes of honeysuckle, mandarin, amber, and sandalwood.\n\n-4 oz. soy candle in a gold tin with lid.\n\n-Burn time: 15-20 hours.\n\n-Hand-poured in small batches with soy wax, premium fragrance, and cotton wicks.\n\n-Made in the USA.\n\n-Vegan, free of phthalates and parabens, and cruelty-free.",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:44.079Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
